export const htmlId: string = 'orders-details-inside';
